import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Typography, 
} from '@mui/material';
import TableCells from 'src/components/Tables/TableCells';
import { useMain } from '../hooks/useMain';
import { useNavigate } from 'react-router';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import star_img from 'src/assets/images/star.png';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import { BiNote } from 'react-icons/bi';
import { Autocomplete, TextField } from "@mui/material";
import AddProductConsume from './productConsume/AddProductConsume';
import CheckboxInputs from 'src/components/inputs/CheckboxInputs';

export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

const FieldData = ({ data,allData, setData, getData,setCheckedClients,checkedClients, billType, ownerId, allClient, hasActiveFilters,  isAllChecked, setIsAllChecked }) => {
  const { deleteBilling, setShowMessage, branchData, getAllStaff, activeBranchId, updateBill } =
    useMain();

  const [selectedItem, setSelectedItem] = useState(null);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [serviceProviders, setServiceProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateMask, setUpdateMask] = useState(false);
  const [formServices, setFormServices] = useState({});
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [productConsumeDialog, setProductConsumeDialog] = useState({
    open: false,
    billId: null,
  });

  const navigate = useNavigate();

   // Use allData for selection logic, data for display
  const selectionData = hasActiveFilters ? allData : data;

  const handleOpenProductConsume = (billId) => {
    setProductConsumeDialog({ open: true, billId });
  };

  const handleCloseProductConsume = () => {
    setProductConsumeDialog({ open: false, billId: null });
    getData()
  };

  const handleDatails = (id) => {
    navigate(`/billing/${id}`, { state: { ownerId } });
  };

  useEffect(() => {
    setUpdateMask(!updateMask);
  }, [branchData?.isMasked]);

  const handleCloseDialogue = () => {
    setSelectedItem(null);
    setUpdateFormData({});
    setOpenDialogue(false);
  };


  // const handleUpdate = (item) => {
  //   setSelectedItem(item);
  //   setFormServices(item);
  //   console.log()
  //   const { dateOfBilling, timeOfBilling, amountPaid, paidDues, services, reasonForUpdate } = item;
  //   console.log(item,'item')
  //   console.log(selectedItem,'selectedItem')
  //   setUpdateFormData({
  //     ...item,
  //     dateOfBilling,
  //     timeOfBilling,
  //     paidDues,
  //     reasonForUpdate,
  //     amountPaid: amountPaid.map(({ amount, paymentType, _id }) => ({
  //       paymentType,
  //       amount,
  //       _id,
  //     })),
  //     services: services.map((el) => ({
  //       ...el,
  //       serviceProvider: el?.serviceProvider || {}, // Retain the existing serviceProvider object
  //     })),
  //   });

  //   setOpenDialogue(true);
  // };
  const handleUpdate = (item) => {
    setSelectedItem(item);
    setFormServices(item);

    const { dateOfBilling, timeOfBilling, amountPaid, paidDues, services, products, reasonForUpdate } = item;

    // Filter out empty product objects that don't have productName
    const validProducts = products ? products.filter(product => product && product.productName) : [];

    // Filter out empty service objects that don't have serviceName
    const validServices = services ? services.filter(service => service && service.serviceName) : [];

    setUpdateFormData({
      ...item,
      dateOfBilling,
      timeOfBilling,
      paidDues,
      reasonForUpdate,
      amountPaid: amountPaid.map(({ amount, paymentType, _id }) => ({
        paymentType,
        amount,
        _id,
      })),
      services: validServices.map((el) => ({
        ...el,
        serviceProvider: el?.serviceProvider || {},
      })),
      products: validProducts, // Use filtered products array
    });

    setOpenDialogue(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateFormData((pre) => ({ ...pre, [name]: value }));
  };

  const handleAmountPaidInputChange = (e, index) => {
    const { name, value } = e.target;
    const newAmountPaid = [...updateFormData.amountPaid];

    if (name === 'amount') {
      newAmountPaid[index].amount = value;

      // Update the amount due only after the amount is set
      const totalPaid = newAmountPaid.reduce((acc, item) => acc + Number(item.amount), 0);
      const newDues = selectedItem?.totalAmount - totalPaid;

      setUpdateFormData({
        ...updateFormData,
        amountPaid: newAmountPaid,
        paidDues: newDues >= 0 ? newDues : 0, // Ensure dues don't go negative
      });
    } else {
      newAmountPaid[index][name] = value;
      setUpdateFormData({
        ...updateFormData,
        amountPaid: newAmountPaid,
      });
    }
  };

  const addAmountPaidRow = () => {
    const isUnselectedamountPaid = updateFormData?.amountPaid?.some(
      (item) => item.amount === '' || Number(item.amount) === 0,
    );
    if (isUnselectedamountPaid)
      return setShowMessage({ message: 'please fill the amount field', messageType: 'error' });
    const newAmountPaid = {
      paymentType: 'Cash',
      amount: '',
    };
    const addNewAmountPaid = [...updateFormData.amountPaid, newAmountPaid];
    setUpdateFormData((pre) => ({ ...pre, amountPaid: addNewAmountPaid }));
  };

  const deleteAmountPaidRow = (index) => {
    const updatedAmountPaid = updateFormData?.amountPaid?.filter(
      (_, currentIndex) => currentIndex !== index,
    );
    const paidDues =
      selectedItem.amountPayable +
      updatedAmountPaid.reduce((acc, payment) => acc + Number(payment.amount), 0);
    setUpdateFormData((pre) => ({
      ...pre,
      amountPaid: updatedAmountPaid,
      paidDues,
    }));
  };
  const handleUpdateBill = async () => {
    setLoading(true);
    try {
      const res = await updateBill(selectedItem._id, `?branchId=${activeBranchId}`, updateFormData);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'bill update successfully',
          messageType: 'success',
        });
        getData();
        setSelectedItem(null);
        setUpdateFormData({});
        setOpenDialogue(false);
      } else {
        setShowMessage({ message: res.message || 'bill not update', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteField = (id) => {
    setDeleteId(id); // Set the ID to be deleted
    setOpenDeleteDialog(true); // Open confirmation dialog
  };

  const confirmDelete = async () => {
    setDeleteLoading(true); // Start loading
    try {
      const res = await deleteBilling(deleteId, activeBranchId);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Bill deleted successfully',
          messageType: 'success',
        });
        setData(data?.filter((d) => d?._id !== deleteId));
        await getData(); // Refresh the data after deletion
      } else {
        setShowMessage({
          message: res.message || 'Bill not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setOpenDeleteDialog(false); // Close dialog after operation
      setDeleteId(null); // Reset delete ID
      setDeleteLoading(false); // Stop loading
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  useEffect(() => {
    const fetchServiceProviders = async () => {
      try {
        const response = await getAllStaff(activeBranchId);
        if (response?.data) {
          setServiceProviders(response.data);
        } else {
          console.error('Failed to fetch service providers: No data in response');
        }
      } catch (error) {
        console.error('Error fetching service providers:', error);
      }
    };

    fetchServiceProviders();
  }, [activeBranchId]); // Dependency array ensures it runs when activeBranchId changes

  const handleProviderChange = (index, newValue, isProduct = false) => {
    setUpdateFormData((prev) => {
      const updatedData = { ...prev };

      if (isProduct) {
        const updatedProducts = [...updatedData.products];
        updatedProducts[index].productProviderDetails = newValue;
        updatedProducts[index].productProvider = newValue.map(provider => provider._id);
        updatedData.products = updatedProducts;
      } else {
        const updatedServices = [...updatedData.services];
        updatedServices[index].serviceProviderDetails = newValue;
        updatedServices[index].serviceProvider = newValue.map(provider => provider._id);
        updatedData.services = updatedServices;
      }

      return updatedData;
    });
  };


  // Generate table headers based on billType
  const getTableHeaders = () => {
    const baseHeaders = [
      { name: 'Date of Bill', width: '10%' },
      { name: 'Client Name', width: '12%' },
      { name: 'Contact', width: '12%' },
      { name: 'Gender', width: '8%' },
    ];

    // Add service-related headers only for Bill type
    if (billType === 'Bill') {
      baseHeaders.push(
        { name: 'Services and Products', width: '15%' },
        { name: 'Service Provider', width: '12%' }
      );
    }

    baseHeaders.push(
      { name: 'Total', width: '8%' },
      { name: 'Paid', width: '8%' }
    );

    // Add wallet-specific header
    if (billType === 'Wallet') {
      baseHeaders.push({ name: 'Value of Amount', width: '10%' });
    }

    // Add pending amount for Bill type
    if (billType === 'Bill' || billType === "Wallet") {
      baseHeaders.push({ name: 'Pending', width: '8%' });
    }

    baseHeaders.push(
      { name: 'Mode of Payment', width: '10%' },
      { name: 'Actions', width: '12%' }
    );

    // Add product consumption for Bill type
    if (billType === 'Bill') {
      baseHeaders.push({ name: 'Product Consume', width: '10%' });
    }

    return baseHeaders;
  };
          const getGridTemplate = () => {
            const headers = getTableHeaders();
            // Convert each header's percentage width into a flexible fr unit, checkbox gets a fixed 30px
            const columns = headers.map((h) => {
              const percent = parseFloat(h.width); // e.g. '10%' -> 10
              return `${percent}fr`;
            });
            return `30px ${columns.join(' ')}`;
          };

          const gridRowStyle = {
            display: 'grid',
            gridTemplateColumns: getGridTemplate(),
            alignItems: 'center',
            columnGap: '8px',
          };
 
  const findClientId = (clientNumber, clientName) => {

    // Use the client data from branchData or wherever it's available
    const clients = allClient || [];
    const matchingClient = clients.find(
      client =>
        client.clientNumber === clientNumber &&
        client.clientName === clientName
    );
    return matchingClient ? matchingClient._id : null;
  };
  // console.log(branchData,'branchData')
  const handleClientDetails = (clientNumber, clientName) => {
    const clientId = findClientId(clientNumber, clientName);

    if (clientId) {
      navigate(`/client/${clientId}`);

    } else {
      setShowMessage({
        message: 'Client details not found',
        messageType: 'error'
      });
    }
  };

  //  const handleAllCheckboxChange = () => {
  //   if (isAllChecked) {
  //     setCheckedClients([]);
  //   } else {
  //     setCheckedClients(data);
  //   }
  //   setIsAllChecked(!isAllChecked);
  // };

  //   const handleSignleCheckboxChange = (clientId) => {
  //   if (checkedClients.length && checkedClients.some((check) => check._id === clientId)) {
  //     setCheckedClients((prev) => prev.filter((check) => check._id !== clientId));
  //   } else {
  //     const checked = data.filter((item) => item._id === clientId);
  //     setCheckedClients((prev) => [...prev, ...checked]); // Create a new array
  //   }
  // };

  //   useEffect(() => {
  //   setIsAllChecked((data?.length && checkedClients?.length === data?.length) || false);
  // }, [checkedClients.length, data?.length]);

   const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setCheckedClients([]);
      setIsAllChecked(false);
    } else {
      const clientsToSelect = selectionData.filter(item => 
        item.clientNumber && item.clientName
      );
      setCheckedClients(clientsToSelect);
      setIsAllChecked(true);
    }
  };

 // ✅ CORRECTED selection logic - current page data ke saath work karega
const handleSignleCheckboxChange = (clientId) => {
  const isCurrentlyChecked = checkedClients.some((check) => check._id === clientId);
  
  if (isCurrentlyChecked) {
    const newCheckedClients = checkedClients.filter((check) => check._id !== clientId);
    setCheckedClients(newCheckedClients);
    setIsAllChecked(false);
  } else {
    // ✅ Sirf current page data mein se select karein
    const clientToAdd = data.find((item) => item._id === clientId);
    if (clientToAdd) {
      const newCheckedClients = [...checkedClients, clientToAdd];
      setCheckedClients(newCheckedClients);
      
      // Check if all current page items are selected
      const allSelected = newCheckedClients.length === data.length;
      setIsAllChecked(allSelected);
    }
  }
};

  // ✅ CORRECTED useEffect - Use props
  useEffect(() => {
    if (selectionData.length === 0) {
      setIsAllChecked(false);
      return;
    }

    const allSelected = selectionData.length > 0 && 
                       checkedClients.length === selectionData.length && 
                       selectionData.every(item => 
                         checkedClients.some(checked => checked._id === item._id)
                       );
    setIsAllChecked(allSelected);
  }, [checkedClients, selectionData, setIsAllChecked]);

  return (
      <Box sx={{ width: '100%' }}>
          <table className="table-container mt-3" style={{ width: '100%' }}>        
            <thead className="table-thead">
          <tr style={gridRowStyle}>
            <th>
              <CheckboxInputs
                type={'Heading'}
                isAllChecked={isAllChecked}
                handleAllCheckboxChange={handleAllCheckboxChange}
              />
            </th>
            {getTableHeaders().map((header, index) => (
              <th
                key={index}
                style={{
                  textAlign: "center",
                  padding: '8px',
                  fontWeight: 'bold'
                }}
              >
                {header.name}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="table-tbody">
          {data.map((item) => {
            const originalDate = item?.dateOfBilling;
            let formattedBillDate = '';
            if (originalDate) {
              const [year, month, day] = originalDate.split('-');
              formattedBillDate = `${day}-${month}-${year}`;
            }

            const allServices = [
              ...item?.services?.map((s) => s?.serviceName).filter(Boolean) || [],
              ...item?.products?.map((p) => p?.productName).filter(Boolean) || [],
            ];

            const allProviders = [
              ...(item?.services
                ?.flatMap((s) => s?.serviceProviderDetails?.map((p) => p?.name) || [])
                .filter(Boolean) || []),
              ...(item?.products?.flatMap((p) => p?.productProviderDetails?.map((e) => e.name)).filter(Boolean) ||
                []),
            ];

            // Extract payment types for hover functionality
            const paymentTypes = item?.amountPaid?.map(({ paymentType }) => paymentType).filter(Boolean);

            // Check if this is a Due bill
            const isDueBill = item.createdBillFor === 'Due';

            return (
              <tr key={item._id} style={gridRowStyle}>
                <td>
                  <CheckboxInputs
                    type={'content'}
                    handleSignleCheckboxChange={handleSignleCheckboxChange}
                    checkedItems={checkedClients}
                    fieldId={item?._id}
                  />
                </td>
                {/* Date of Bill */}
                <td style={{ textAlign: 'center', padding: '8px' , whiteSpace: 'nowrap' }}>
                  {formattedBillDate}
                </td>

                {/* Client Name */}
                <td style={{ textAlign: 'center', padding: '8px' }}>
                  {TrimData(item?.clientName)}
                </td>

                {/* Contact */}
                <td style={{ textAlign: 'center', padding: '8px' }}>
                  {typeof branchData?.isMasked !== 'boolean' || !item?.clientNumber
                    ? 'loading...'
                    : maskData(item?.clientNumber, branchData?.isMasked)}
                </td>

                {/* Gender */}
                <td style={{ textAlign: 'center', padding: '8px' }}>
                  {item?.gender}
                </td>

                {/* Services and Products column - only for Bill type */}
                {billType === 'Bill' && (
                  <td style={{ textAlign: 'center', padding: '8px', position: 'relative' }}>
                    {isDueBill ? (
                      <span>-</span>
                    ) : (
                      <div
                        onMouseEnter={() => setHoveredItemId(item._id + '_services')}
                        onMouseLeave={() => setHoveredItemId(null)}
                        style={{ cursor: 'pointer' }}
                      >
                        {allServices.slice(0, 1).join(', ')}
                        {allServices.length > 1 && ' ...'}

                        {hoveredItemId === item._id + '_services' && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              backgroundColor: '#dfe3f8',
                              border: '1px solid #ccc',
                              padding: '8px',
                              borderRadius: '5px',
                              zIndex: 5,
                              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                              whiteSpace: 'pre-wrap',
                              maxWidth: '300px',
                            }}
                          >
                            {allServices.join(', ')}
                          </div>
                        )}
                      </div>
                    )}
                  </td>
                )}

                {/* Service Provider column - only for Bill type */}
                {billType === 'Bill' && (
                  <td style={{ textAlign: 'center', padding: '8px', position: 'relative' }}>
                    {isDueBill ? (
                      <span>-</span>
                    ) : (
                      <div
                        onMouseEnter={() => setHoveredItemId(item._id + '_providers')}
                        onMouseLeave={() => setHoveredItemId(null)}
                        style={{ cursor: 'pointer' }}
                      >
                        {allProviders.slice(0, 1).join(', ')}
                        {allProviders.length > 1 && ' ...'}

                        {hoveredItemId === item._id + '_providers' && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              backgroundColor: '#dfe3f8',
                              border: '1px solid #ccc',
                              padding: '8px',
                              borderRadius: '5px',
                              zIndex: 5,
                              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                              whiteSpace: 'pre-wrap',
                              maxWidth: '300px',
                            }}
                          >
                            {allProviders.join(', ')}
                          </div>
                        )}
                      </div>
                    )}
                  </td>
                )}

                {/* Total */}
                <td style={{ textAlign: 'center', padding: '8px' , position: 'relative'  }}>
                  {item?.amountPayable}
                </td>

                {/* Paid */}
                <td style={{ textAlign: 'center', padding: '8px' }}>
                  {item?.amountPaid.reduce((acc, payment) => acc + Number(payment.amount), 0)}
                </td>

                {/* Value of Amount - only for Wallet type */}
                {billType === 'Wallet' && (
                  <td style={{ textAlign: 'center', padding: '8px' }}>
                    {item?.amountAdded ? item.amountAdded : item?.amountPaid.reduce((acc, payment) => acc + Number(payment.amount), 0)}
                  </td>
                )}

                {/* Pending - only for Bill type */}
                {/* {billType === 'Bill' || billType === "Wallet" && (
                  <td style={{ width: '8%', textAlign: 'center', padding: '8px' }}>
                    {item?.paidDues || 0}
                  </td>
                )} */}
                <td style={{ textAlign: 'center', padding: '8px' }}>
                  {item?.paidDues || 0}
                </td>

                {/* Mode of Payment */}
                <td style={{ textAlign: 'center', padding: '8px', position: 'relative' }}>
                  <div
                    onMouseEnter={() => setHoveredItemId(item._id + '_payments')}
                    onMouseLeave={() => setHoveredItemId(null)}
                    style={{ cursor: paymentTypes.length > 1 ? 'pointer' : 'default' }}
                  >
                    {paymentTypes.slice(0, 1).join(', ')}
                    {paymentTypes.length > 1 && ' ...'}

                    {hoveredItemId === item._id + '_payments' && paymentTypes.length > 1 && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          backgroundColor: '#dfe3f8',
                          border: '1px solid #ccc',
                          padding: '8px',
                          borderRadius: '5px',
                          zIndex: 5,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          whiteSpace: 'pre-wrap',
                          maxWidth: '300px',

                        }}
                      >
                        {paymentTypes.join(', ')}
                      </div>
                    )}
                  </div>
                </td>

                {/* Actions column - show "Due Bill" text for Due bills instead of action buttons */}
                {/* <td style={{ width: '12%', textAlign: 'center', padding: '8px' }}>
                  {isDueBill ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}>
                      <IconButton
                        onClick={() => handleClientDetails(item.clientNumber, item.clientName)}
                        color="primary"
                        title="View Client Details"
                        size="small"
                      >
                        <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                      </IconButton>
                      <span style={{ fontWeight: 'bold', color: '#ff4d4d' }}>Due Bill</span>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0px' }}>
                      <IconButton
                        onClick={() => handleDatails(item._id)}
                        color="primary"
                        title="View Details"
                        size="small"
                        style={{ padding: '2px' }}   // 👈 default 8px hota hai, isse kam karo
                      >
                        <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                      </IconButton>

                      <IconButton
                        onClick={() => handleUpdate(item)}
                        color="secondary"
                        title="Update"
                        size="small"
                        style={{ padding: '2px' }}
                      >
                        <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                      </IconButton>

                      <IconButton
                        onClick={() => handleDeleteField(item._id)}
                        color="error"
                        title="Delete"
                        size="small"
                        style={{ padding: '2px' }}
                      >
                        <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                      </IconButton>

                      <div style={{ position: 'relative' }}>
                        <IconButton
                          onMouseEnter={() => setHoveredItemId(item._id)}
                          onMouseLeave={() => setHoveredItemId(null)}
                          title="View Notes"
                          size="small"
                          style={{ padding: '2px' }}
                        >
                          <BiNote style={{ color: 'rgb(135 127 127)', fontSize: '1.2rem' }} />
                        </IconButton>

                        {hoveredItemId === item._id && (
                          <div
                            style={{
                              width: '150px',
                              position: 'absolute',
                              top: '50%',
                              right: '120%',
                              transform: 'translateY(-50%)',
                              backgroundColor: 'white',
                              border: '1px solid #ccc',
                              borderRadius: '5px',
                              padding: '8px',
                              zIndex: 1,
                              boxShadow:
                                'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
                              whiteSpace: 'wrap',
                            }}
                          >
                            {item?.notes ? item.notes : 'No notes'}
                          </div>
                        )}
                      </div>
                    </div>

                  )}
                </td> */}
                <td style={{ textAlign: 'center', padding: '8px' }}>
  {isDueBill ? (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}>
      <IconButton
        onClick={() => handleDatails(item._id)}
        color="primary"
        title="View Details"
        size="small"
      >
        <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
      </IconButton>
  <span style={{ fontWeight: 'bold', color: '#ff4d4d', fontSize: '0.7rem', whiteSpace: 'nowrap' }}>Due Bill</span>
    </div>
  ) : (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0px' }}>
      {/* Info Icon - Always show */}
      <IconButton
        onClick={() => handleDatails(item._id)}
        color="primary"
        title="View Details"
        size="small"
        style={{ padding: '2px' }}
      >
        <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
      </IconButton>

      {/* Update & Delete icons - Show only if availability === true */}
      {item?.availability !== false && (
        <>
          <IconButton
            onClick={() => handleUpdate(item)}
            color="secondary"
            title="Update"
            size="small"
            style={{ padding: '2px' }}
          >
            <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
          </IconButton>

          <IconButton
            onClick={() => handleDeleteField(item._id)}
            color="error"
            title="Delete"
            size="small"
            style={{ padding: '2px' }}
          >
            <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
          </IconButton>
        </>
      )}

      {/* Notes Icon - Always show */}
      <div style={{ position: 'relative' }}>
        <IconButton
          onMouseEnter={() => setHoveredItemId(item._id)}
          onMouseLeave={() => setHoveredItemId(null)}
          title="View Notes"
          size="small"
          style={{ padding: '2px' }}
        >
          <BiNote style={{ color: 'rgb(135 127 127)', fontSize: '1.2rem' }} />
        </IconButton>

        {hoveredItemId === item._id && (
          <div
            style={{
              width: '150px',
              position: 'absolute',
              top: '50%',
              right: '120%',
              transform: 'translateY(-50%)',
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '5px',
              padding: '8px',
              zIndex: 1,
              boxShadow:
                'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
              whiteSpace: 'wrap',
            }}
          >
            <Typography variant="body2" fontWeight="bold">Bill Note:</Typography>
            <Typography variant="body2">{item?.notes ? item.notes : 'No notes'}</Typography>
            <Typography variant="body2" fontWeight="bold" mt={1}>Note For Client:</Typography>
            <Typography variant="body2">{item?.noteForClient ? item.noteForClient : 'No client note'}</Typography>
          </div>
        )}
      </div>
    </div>
  )}
</td>


                {/* Product Consumption column - only for Bill type */}
                {/* {billType === 'Bill' && (
                  <td style={{ width: '10%', textAlign: 'center', padding: '8px' }}>
                    {isDueBill ? (
                      <span>-</span>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleOpenProductConsume(item._id)}
                        disabled={item.productsConsumed === true}
                        sx={{ fontSize: '0.75rem', padding: '4px 8px' }}
                      >
                        Product consume
                      </Button>
                    )}
                  </td>
                )} */}
                {billType === 'Bill' && (
  <td style={{ width: '10%', textAlign: 'center', padding: '8px' }}>
    {item?.availability === false ? (
      <span>-</span>
    ) : isDueBill ? (
      <span>-</span>
    ) : (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={() => handleOpenProductConsume(item._id)}
        disabled={item.productsConsumed === true}
        sx={{ fontSize: '0.75rem', padding: '4px 8px' }}
      >
        Product consume
      </Button>
    )}
  </td>
)}

              </tr>
            );
          })}
        </tbody>
      </table>
      {/* Add Product Consume Dialog */}
      <Dialog
        open={productConsumeDialog.open}
        onClose={handleCloseProductConsume}
        maxWidth="md"
        fullWidth
      >
        {/* <DialogTitle>Add Product Consumption</DialogTitle> */}
        <DialogContent>
          {productConsumeDialog.billId && (
            <AddProductConsume
              billId={productConsumeDialog.billId}
              onClose={handleCloseProductConsume}
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogContent>Are you sure you want to delete this bill?</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary" disabled={deleteLoading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialogue}
        onClose={handleCloseDialogue}
        PaperProps={{
          style: {
            maxWidth: '1200px',
            width: '90%',
            minHeight: '80%',
          },
        }}
      >
        <DialogContent>
          <div>
            <div className="mb-3">
              <form className="row">
                <div className="col-md-3 text-start">
                  <label for="exampleInputEmail1" className="form-label">
                    Date of Billing
                  </label>
                  <input
                    type="date"
                    max={new Date().toISOString().split('T')[0]}
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    value={updateFormData?.dateOfBilling}
                    name="dateOfBilling"
                    onChange={handleInputChange}
                  // disabled
                  />
                </div>
                <div className="col-md-3 text-start">
                  <label for="exampleInputEmail1" className="form-label">
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputEmail1"
                    placeholder="client Number"
                    aria-describedby="emailHelp"
                    value={selectedItem?.clientNumber}
                    name="clientNumber"
                    disabled
                  />
                </div>
                <div className="col-md-3 text-start">
                  <label for="exampleInputEmail1" className="form-label">
                    Client Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="client name"
                    value={selectedItem?.clientName}
                    name="clientName"
                    disabled
                  />
                </div>
                <div className="col-md-3 text-start">
                  <label for="exampleInputEmail1" className="form-label">
                    Time of Billing
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    value={updateFormData?.timeOfBilling}
                    name="timeOfBilling"
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3 text-start">
                  <label for="exampleInputEmail1" className="form-label">
                    Service For
                  </label>
                  <select
                    class="form-select"
                    className="form-select"
                    aria-label="Default select example"
                    name="gender"
                    value={selectedItem?.gender}
                    disabled
                  >
                    <option value="" disabled>
                      --select gender--
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </form>
            </div>
            <div class="table-responsive responsive_tbl">
              <table class="table table-bordered">
                <thead>
                  <tr className="list">
                    <th className="col-md-3">Service / Products / Packages</th>
                    <th className="col-md-2">Service provider</th>
                    <th className="col-md-1">Qty</th>
                    <th className="col-sm-2">Discount</th>
                    <th className="col-md-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {updateFormData?.services?.length > 0 && updateFormData.services.map((service, index) => (
                    service.serviceName && ( // Only render if serviceName exists
                      <tr key={index}>
                        <td className="col-md-3">
                          <div className="d-flex grid gap-2 align-items-center col-md-12">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Service"
                              name="serviceName"
                              value={service?.serviceName}
                              disabled
                            />
                          </div>
                        </td>
                        <td className="col-md-2">
                          <Autocomplete
                            multiple
                            disabled
                            options={serviceProviders}
                            value={service?.serviceProviderDetails || []}
                            getOptionLabel={o => o.name}
                            isOptionEqualToValue={(opt, val) => opt._id === val._id}
                            renderInput={params => (
                              <TextField {...params} label="Service Providers" size="small" />
                            )}
                            sx={{
                              width: 250,
                              '& .MuiAutocomplete-listbox': {
                                maxHeight: 120,
                              },
                            }}
                            ListboxProps={{
                              style: { maxHeight: 120, overflowY: 'auto' },
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            min={1}
                            class="form-control ser_cat"
                            placeholder="Qty"
                            name="quantity"
                            value={service?.quantity}
                            disabled
                          />
                        </td>
                        <td className="col-sm-2">
                          <div className="col-md-12 d-flex grid gap-2 align-items-center">
                            <input
                              type="number"
                              class="form-control ser_cat"
                              min={0}
                              placeholder="0"
                              name="discount"
                              value={service?.discount}
                              disabled
                            />
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              name="discountType"
                              value={service?.discountType} // Changed from formServices to service
                              disabled
                            >
                              <option value="%">%</option>
                              <option value="INR">INR</option>
                            </select>
                          </div>
                        </td>
                        <td className="col-md-2">
                          <input
                            type="number"
                            min={0}
                            class="form-control ser_cat"
                            placeholder="amount"
                            name="amount"
                            value={service?.amount}
                            disabled
                          />
                        </td>
                      </tr>
                    )
                  ))}
                  {updateFormData?.products?.length > 0 && updateFormData.products.map((formProduct, index) => (
                    formProduct.productName && ( // Only render if productName exists
                      <tr key={`product-${index}`}>
                        <td className="col-md-3">
                          <div className="d-flex grid gap-2 align-items-center col-md-12">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Product"
                              name="productName"
                              value={formProduct?.productName}
                              disabled
                            />
                          </div>
                        </td>
                        {/* <td className="col-md-2">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            name="providerStaff"
                            disabled
                          ></select>
                        </td> */}
                        <td className="col-md-2">
                          <Autocomplete
                            multiple
                            disabled
                            options={serviceProviders}
                            value={formProduct?.productProviderDetails || []}
                            getOptionLabel={o => o.name}
                            isOptionEqualToValue={(opt, val) => opt._id === val._id}
                            renderInput={params => (
                              <TextField {...params} label="Product Providers" size="small" />
                            )}
                            sx={{
                              width: 250,
                              '& .MuiAutocomplete-listbox': {
                                maxHeight: 120,
                              },
                            }}
                            ListboxProps={{
                              style: { maxHeight: 120, overflowY: 'auto' },
                            }}
                          />
                        </td>
                        <td className="col-sm-1">
                          <input
                            type="number"
                            className="form-control ser_cat"
                            min={1}
                            placeholder="0"
                            name="quantity"
                            value={formProduct?.quantity}
                            disabled
                          />
                        </td>
                        <td className="col-sm-2">
                          <div className="col-md-12 d-flex grid gap-2 align-items-center">
                            <input
                              type="number"
                              min={0}
                              className="form-control ser_cat"
                              placeholder="0"
                              name="discount"
                              value={formProduct?.discount}
                              disabled
                            />
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              name="discountType"
                              value={formProduct?.discountType}
                              disabled
                            >
                              <option value="%">%</option>
                              <option value="INR">INR</option>
                            </select>
                          </div>
                        </td>
                        <td className="col-md-2">
                          <input
                            type="number"
                            min={0}
                            class="form-control ser_cat"
                            name="amount"
                            value={formProduct?.amount}
                            disabled
                          />
                        </td>
                      </tr>
                    )
                  ))}
                </tbody>
              </table>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td>Subtotal</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span>INR&nbsp;&nbsp;{selectedItem?.subTotal}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Membership</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      {selectedItem?.useMembership && (
                        <>
                          <span style={{ color: 'green' }}>Applied</span>
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Taxes</td>
                    <td className="col-md-4">
                      <select className="form-select" disabled value="current">
                        <option value="current">
                          {(() => {
                            const taxes = selectedItem?.taxes;
                            const type = taxes?.taxType;
                            const subTotal = Number(selectedItem?.subTotal || 0);
                            const totalAmount = Number(selectedItem?.totalAmount || 0);

                            // Check explicit types first
                            if (type === 'Exclusive') return 'Exclusive';
                            if (type === 'Inclusive' || type === 'Ingst') return 'Inclusive';

                            // Fallback detection
                            if (totalAmount > subTotal) return 'Exclusive';

                            if (totalAmount === subTotal && totalAmount > 0) {
                              const items = [...(selectedItem?.services || []), ...(selectedItem?.products || [])]
                                .filter(item => item && (item.serviceName || item.productName));
                              const totalLineAmount = items.reduce((acc, item) => acc + Number(item.amount || 0), 0);

                              // If subtotal matches the sum of line amounts (after discounts), no GST was applied
                              if (Math.abs(subTotal - totalLineAmount) < 1) {
                                return 'No GST';
                              }
                              return 'Inclusive';
                            }
                            return 'No GST';
                          })()}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Discount</td>
                    <td className="col-md-2">
                      <div className="col-md-12 d-flex grid gap-2 align-items-center">
                        <input
                          type="number"
                          class="form-control ser_cat"
                          min={0}
                          placeholder="0"
                          name="discount"
                          value={selectedItem?.discount?.discount}
                          disabled
                        />
                        <select
                          class="form-select"
                          aria-label="Default select example"
                          name="discountType"
                          value={selectedItem?.discount?.discountType}
                          disabled
                        >
                          <option value="%">%</option>
                          <option value="INR">INR</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td> Total</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span>INR&nbsp;&nbsp;{selectedItem?.totalAmount}</span>
                    </td>
                  </tr>
                  <tr>
                    <td> Coupon</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      {selectedItem?.coupon?.couponId && (
                        <>
                          <span>{selectedItem?.coupon?.couponCode} </span>
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Current Amount</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span>&nbsp;&nbsp;{selectedItem?.amountPayable}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ fontWeight: 'bold' }}>Net Amount</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold' }}>
                        &nbsp;&nbsp;{selectedItem?.amountPayable}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td> Amount paid</td>
                    <td className="col-md-4" colspan="2">
                      {updateFormData?.amountPaid?.map((amountPaid, index) => (
                        <table key={index}>
                          <tr style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <td>
                              <input
                                type="number"
                                step="1"
                                className="form-control"
                                min="0"
                                name="amount"
                                placeholder="0"
                                value={amountPaid?.amount}
                                onChange={(e) => handleAmountPaidInputChange(e, index)}
                                disabled
                              />
                            </td>
                            <td>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                data-validation="required"
                                name="paymentType"
                                value={amountPaid?.paymentType}
                                onChange={(e) => handleAmountPaidInputChange(e, index)}
                              >
                                <option value="" disabled>
                                  --Select--
                                </option>
                                <option value="Cash">Cash</option>
                                <option value="Credit/Debit Card">Credit/Debit card</option>
                                <option value="Paytm">Paytm</option>
                                <option value="PhonePe">PhonePe</option>
                                <option value="Gpay">Gpay</option>
                              </select>
                            </td>
                            <td>
                              {index === 0 ? (
                                <span class="input-group-btn">
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    target="_blank"
                                    sx={{
                                      background: '#6174DD',
                                      fontSize: '15px',
                                      fontWeight: 'bold',
                                    }}
                                    onClick={addAmountPaidRow}
                                  >
                                    <span class="bi bi-plus small"></span>
                                  </Button>
                                </span>
                              ) : (
                                <span class="input-group-btn">
                                  <Button
                                    variant="contained"
                                    color="error"
                                    target="_blank"
                                    sx={{
                                      background: '#bb2d3b',
                                      fontSize: '15px',
                                      fontWeight: 'bold',
                                    }}
                                    onClick={() => deleteAmountPaidRow(index)}
                                  >
                                    <span class="bi bi-dash small"></span>
                                  </Button>
                                </span>
                              )}
                            </td>
                          </tr>
                        </table>
                      ))}

                    </td>
                  </tr>
                  <tr>
                    <td>New Amount due</td>
                    <td className="col-md-2" style={{ textAlign: 'center' }}>
                      <span name="paidDues">
                        INR&nbsp;&nbsp;
                        {updateFormData?.paidDues}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7">
                      <textarea
                        class="form-control no-resize"
                        rows="2"
                        placeholder="Write bill update reason..."
                        id="textArea"
                        name="reasonForUpdate"
                        value={updateFormData?.reasonForUpdate}
                        onChange={handleInputChange}
                      ></textarea>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <ShowLoader />
          ) : (
            <>
              <div>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleCloseDialogue}
                >
                  Cancel
                </Button>
              </div>
              <div>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleUpdateBill}
                >
                  update
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FieldData;
